export default __webpack_public_path__ + "static/one-percent-for-the-planet-f1f03d6c902f7dd97366f707619e1610.svg";